// 分销管理————分销渠道管理
import http from "@/utils/request";

// 添加渠道、编辑渠道
export function httpChannelAdd(data: any) {
  return http.post<Res.response<any>>({
    url: "/distribution/channel/add",
    data,
  });
}
// 查看分佣商户
export function httpChannelCommissionMerchantList(data: any) {
  return http.post<Res.response<any>>({
    url: "/distribution/channel/commission/merchant/list",
    data,
  });
}
// 分销渠道列表
export function httpChannelList(data: any) {
  return http.post<Res.response<any>>({
    url: "/distribution/channel/list",
    data,
  });
}
// 分销渠道列表下拉框
export function httpChannelSelectList() {
  return http.post<Res.response<any>>({
    url: "/distribution/channel/select/list",
  });
}
